import React from 'react';

const ExistingProjectCTA: React.FC = () => {
  return (
    <section className="bg-royal-blue py-12 lg:py-16 relative overflow-hidden">
      {/* Decorative circles — hidden on mobile */}
      <div className="absolute left-4 lg:left-[226px] top-1/2 -translate-y-1/3 w-[336px] h-[336px] pointer-events-none hidden lg:block">
        <div
          className="absolute inset-0 rounded-full opacity-5"
          style={{ background: 'radial-gradient(50% 50% at -29% 62%, rgba(137,146,208,1) 3%, rgba(255,255,255,1) 100%)' }}
        />
        <div
          className="absolute left-[44px] top-[44px] w-[248px] h-[248px] rounded-full opacity-5"
          style={{ background: 'radial-gradient(50% 50% at -29% 62%, rgba(137,146,208,1) 3%, rgba(255,255,255,1) 100%)' }}
        />
        <div className="absolute left-[72px] top-[69px] w-[197px] h-[197px] rounded-full bg-[#4452e340] blur-[18px]" />
      </div>

      <div className="max-w-content mx-auto px-6 flex flex-col lg:flex-row items-center gap-8 lg:gap-12 relative z-10">
        {/* Text content — left side */}
        <div className="flex-1">
          <h2 className="font-exo font-black text-white text-2xl lg:text-[32px] tracking-[1.6px] leading-tight">
            Have an Existing Project That Needs Help?
          </h2>
          <p className="font-proxima text-white text-lg lg:text-2xl tracking-[1.2px] leading-normal mt-4">
            We specialize in rescuing troubled projects, modernizing legacy systems, and fixing performance issues. Our team can audit your code, identify problems, and implement solutions. No project is too complex or too broken for us to fix.
          </p>
          <a
            href="#get-started"
            className="inline-flex items-center justify-center rounded-md overflow-hidden bg-white cursor-pointer py-3 px-5 lg:py-4 lg:px-6 hover:bg-opacity-90 transition-colors mt-8"
          >
            <span className="font-proxima-bold font-bold text-royal-blue text-base lg:text-2xl leading-6 whitespace-nowrap">
              GET STARTED
            </span>
          </a>
        </div>

        {/* Project photo — right side */}
        <div className="flex-shrink-0 w-full max-w-[220px] lg:max-w-[524px] mx-auto lg:mx-0">
          <img
            className="w-full h-auto object-cover rounded"
            src={require('../assets/img/existing-project/project-photo.png')}
            alt="Existing project"
          />
        </div>
      </div>
    </section>
  );
};

export default ExistingProjectCTA;
